export const locationData = [
  {
    name: 'Stevens Pass',
    station: 'OTX',
    x: 25,
    y: 115,
    nwacStations: [17, 18, 50],
    minElevation: 4070,
    minElevationLabel: 'Stevens Pass',
    maxElevation: 5400,
    maxElevationLabel: 'Skyline Ridge',
    noaaLink:
      'https://forecast.weather.gov/MapClick.php?lat=47.7462&lon=-121.0859',
    nwacLink: 'https://nwac.us/avalanche-forecast/#/stevens-pass/',
  },
  {
    name: 'Crystal',
    station: 'SEW',
    x: 145,
    y: 31,
    nwacStations: [27, 28, 29, 54],
    minElevation: 4318,
    minElevationLabel: 'Crystal Base',
    maxElevation: 6700,
    maxElevationLabel: 'Platinum Peak',
    noaaLink:
      'https://forecast.weather.gov/MapClick.php?lat=46.92912043955674&lon=-121.50098133017309&site=sew&unit=0&lg=en&FcstType=text',
    nwacLink: 'https://nwac.us/avalanche-forecast/#/west-slopes-south',
  },
  {
    name: 'Snoqualmie Pass',
    station: 'PDT',
    x: 63,
    y: 197,
    nwacStations: [21, 22, 23, 1, 2, 3],
    minElevation: 3100,
    minElevationLabel: 'Alpental Base',
    maxElevation: 6200,
    maxElevationLabel: 'Snoqualmie Mt Summit',
    noaaLink:
      'https://forecast.weather.gov/MapClick.php?lat=47.4187&lon=-121.412',
    nwacLink: 'https://nwac.us/avalanche-forecast/#/snoqualmie-pass/',
  },
  {
    name: 'Baker',
    station: 'SEW',
    x: 157,
    y: 123,
    nwacStations: [5, 6],
    minElevation: 4265,
    minElevationLabel: 'Heather Meadows',
    maxElevation: 5800,
    maxElevationLabel: 'Mazama Dome',
    noaaLink: 'https://forecast.weather.gov/MapClick.php?lon=-121.68&lat=48.86',
    nwacLink: 'https://nwac.us/avalanche-forecast/#/west-slopes-north/',
  },
  {
    name: 'Paradise',
    station: 'SEW',
    x: 136,
    y: 26,
    nwacStations: [34, 35, 36],
    minElevation: 5400,
    minElevationLabel: 'Paradise',
    maxElevation: 10000,
    maxElevationLabel: 'Camp Muir',
    noaaLink:
      'https://forecast.weather.gov/MapClick.php?CityName=Paradise+Inn&state=WA&site=SEW&textField1=46.7184&textField2=-121.671&e=0',
    nwacLink: 'https://nwac.us/avalanche-forecast/#/west-slopes-south',
  },
];
